import axios from 'axios';
import RecordsForMonth from '../domain/transits/RecordsForMonth';
import Cost from '../domain/cost/Cost';
import Record from '../domain/transits/Record';
import CsvRecord from '../domain/csv/CsvRecord';
import config from '../../config';

const HOST = config().serverUrl;
// const HOST: string = 'http://localhost:8080';

export const fetchOauthUrl = (): Promise<string> =>
  get('/api/google/oauthurl', {});
export const fetchRefreshToken = (code: string): Promise<string> =>
  get('/api/google/refreshtoken', { code });
export const fetchRecords = (
  refreshtoken: string,
  year: number,
  month: number
): Promise<RecordsForMonth> =>
  get(`/api/transits/${year}/${month}`, { refreshtoken });

export const fetchCost = (record: Record): Promise<Cost> =>
  post('/api/yahoo/cost', record);

export const downloadCsv = (csvRecords: CsvRecord[]): Promise<string> =>
  post('/api/csv/download', csvRecords);

async function get<T>(url: string, params: {}): Promise<T> {
  return http(url, { params }, axios.get);
}

async function post<T, U>(url: string, params: T): Promise<U> {
  return http(url, params, axios.post);
}

async function http<T>(url: string, params: T, method: Function): Promise<any> {
  try {
    const response = await method(HOST + url, params);
    return response.data;
  } catch (error) {
    console.error(error);
  }
}



// WEBPACK FOOTER //
// ./src/logic/api/BizServer.ts